import React, { useState } from 'react';
import axios from "axios";
//import axios from "axios";
import { Dropdown, Button, Modal } from 'react-bootstrap';


const Mail_richiesta_dati = (props) => {

    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
   

// toolmemo
    async function Invia_mail_richiesta_dati(parametro_passato) {
        console.log('invia_mail_richiesta_dati');
        let ditta_passata = props.ditta
        ditta_passata.tutor = props.tutor
        if (parametro_passato === 0) {ditta_passata.bozza = "mail_diretta"}
        if (parametro_passato === 1) {ditta_passata.bozza = "bozza_al_tutor_stesso"}

        axios.post('/ditte/invia_mail_richiesta_dati/', ditta_passata)

        axios.patch('/ditte/mail_richiesta_dati/' + props.ditta._id + '/' + '0')
            .then((res) => {
                console.log(res.data)
                //                SET_variab_aggiorna(JSON.stringify(res.data))
            }).catch((error) => {
                console.log(error)
            });
//            <Dropdown.Item onClick={}> Mail Richiesta Dati</Dropdown.Item>
//            <Dropdown.Item onClick={() => Invia_mail_richiesta_dati(1)}> Mail Richiesta Dati (bozza) </Dropdown.Item>
        handleClose()

    }

    return (
        <>
            <Dropdown.Item onClick={() => setShow(true)}> Mail Richiesta Dati</Dropdown.Item>
               {/* idroslab  modal piccolo*/}
 
            <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Invia una mail alla Ditta</Modal.Title>
        </Modal.Header>
        <Modal.Body>Puoi inviare una mail direttamente, oppure modificare una bozza dal tuo gmail</Modal.Body>
        <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
                Annulla
            </Button>
            <Button variant="primary" onClick={() => Invia_mail_richiesta_dati(1)}>
                Bozza alla mia mail
            </Button>
        
            <Button variant="primary" onClick={() => Invia_mail_richiesta_dati(0)}>
                Invio diretto 
            </Button>
        </Modal.Footer>
        </Modal>

        </>
    )
}
export default Mail_richiesta_dati;